import { render, staticRenderFns } from "./TypeNumber.vue?vue&type=template&id=139f4d64&scoped=true&"
import script from "./TypeNumber.vue?vue&type=script&lang=js&"
export * from "./TypeNumber.vue?vue&type=script&lang=js&"
import style0 from "./TypeNumber.vue?vue&type=style&index=0&id=139f4d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f4d64",
  null
  
)

export default component.exports